// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3Qdrk","fileBtn":"File_fileBtn__2hb58","closeBtn":"File_closeBtn__Ozs9V","fileSelected":"File_fileSelected__JIVMf","disabled":"File_disabled__wiDwu"};